import { Component, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AppNotificationUtilClass } from '@monorepo/services';
import { TRfidDevice } from '@monorepo/types';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'monorepo-update-readpower-modal',
  templateUrl: './update-readpower-modal.component.html',
  styleUrls: ['./update-readpower-modal.component.scss'],
})
export class UpdateReadpowerModalComponent {
  @Input() connectedVendor: TRfidDevice['vendor'] = 'APULSETECH';
  @Input() minimumSupportedRange: number = 1;
  @Input() maximumSupportedRange: number = 30;
  @Input() readpower: number = 25;

  constructor(
    private apiHelper: AppNotificationUtilClass,
    private modalController: ModalController,
    private translate: TranslateService,
  ) {}

  onReadpowerChanged($event: number) {
    this.readpower = $event;
  }

  handleCancel() {
    this.modalController.dismiss();
  }

  handleUpdate() {
    if (this.readpower < this.minimumSupportedRange || this.readpower > this.maximumSupportedRange) {
      this.apiHelper.showPopup(
        this.translate.instant('input_app_common.warning'),
        `${this.translate.instant('update_readpower_modal.enterValidValue')} ${
          this.minimumSupportedRange
        } ${this.translate.instant('update_readpower_modal.and')} ${this.maximumSupportedRange}`,
      );
      return;
    }
    this.modalController.dismiss(this.readpower);
  }
}
